import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { PAX_FORM_PLACEHOLDER, getLetterFromIndex } from '../../commons/utils';
import { visualPropTypes } from '../../models/Pax.model';

import './PaxesManager.css';

const VisualList = (props) => {
  const { paxesList, showIcon } = props;

  const customListClass = `data-list__container ${(showIcon) ? 'icon-split' : ''}`;

  return (
    <Row className="auto-margin paxes-visual-list__container">
      {(showIcon) &&
        <Col sm="auto" className="icon__container">
          <i className="fas fa-male"></i>
        </Col>
      }
      <Col className={customListClass}>
        <Row className="auto-margin">
          {
            paxesList.map((pax, index) => {
              const { id, name, surnames } = pax;

              const customKey = `VISUAL-PAX-${index}`;
              const emptyDataLabel = `${PAX_FORM_PLACEHOLDER}${getLetterFromIndex(id - 1)}`;

              const dataName = (name !== '') ? name : emptyDataLabel;
              const dataSurnames = (surnames !== '') ? surnames : emptyDataLabel;

              return (
                <Col sm="12" key={customKey} className="pax-data__container">
                  <div className="indicator-container">
                    <span>{index + 1}</span>
                    <i className="fas fa-bed"></i>
                  </div>
                  <div className="pax-data-row" data-test-label="pax-data">
                    <label>{dataName} {dataSurnames}</label>
                  </div>
                </Col>
              );
            })
          }
        </Row>
      </Col>
    </Row>
  );
};

VisualList.propTypes = {
  paxesList: PropTypes.arrayOf(PropTypes.shape({...visualPropTypes})),
  showIcon: PropTypes.bool
};

VisualList.defaultProps = {
  paxesList: [],
  showIcon: false
};

export default VisualList;
